module.exports = __webpack_public_path__ + "img/portfolio12.0274e8ca.jpg";